import { useEffect, useState } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import SafeHtml from "components/ui/SafeHtml";
import { purifyToText } from "utils/functions/purifyUtil";
import * as c from "./RewardModalDescriptionTask.module.css";

interface RewardModalDescriptionTaskProps {
  description: string[];
  isMobileOs: string;
}

const RewardModalDescriptionTask = ({
  description,
  isMobileOs,
}: RewardModalDescriptionTaskProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const characterLimit = isMobileOs == "" ? 150 : 115;

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const fullDescription = description.join(" ");
  // Truncate on the plain text so markup is never cut in half.
  const plainDescription = purifyToText(fullDescription);
  const isTruncated = plainDescription.length > characterLimit;

  const truncatedDescription = isTruncated
    ? plainDescription.slice(0, characterLimit) + "..."
    : fullDescription;

  useEffect(() => {
    setShowButton(isTruncated);
  }, [isTruncated]);

  return (
    <div className={c.task}>
      <div className={`${c["task-content-container"]} ${isExpanded ? c.expanded : ""}`}>
        {!isExpanded && (
          <SafeHtml as="div" className={c.descriptionText} html={truncatedDescription} />
        )}
        {isExpanded && (
          <SafeHtml as="div" className={c["description-text-expanded"]} html={fullDescription} />
        )}
        {showButton && (
          <button onClick={toggleExpanded} className={c["read-more-button"]}>
            {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
            {isExpanded ? "Read Less" : "Read More"}
          </button>
        )}
      </div>
    </div>
  );
};

export default RewardModalDescriptionTask;
